import service from '@/store/services/settings/attachment-type-service';

const state = {
    list: {},
    attachmentType: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, attachmentType) => {
        state.attachmentType = attachmentType;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(attachmentType => {
                commit('SET_RESOURCE', attachmentType);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(attachmentType => {
                commit('SET_RESOURCE', attachmentType);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((attachmentType) => {
                commit('SET_RESOURCE', attachmentType);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((attachmentType) => {
                commit('SET_RESOURCE', attachmentType);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    attachmentType: state => state.attachmentType,
    dropdown: (state) => {
        return state.list.map(attachmentType => ({
            id: attachmentType.id,
        }));
    }
};

const attachmentTypes = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default attachmentTypes;


